import { backToLogin } from "@/helpers";
import { getToken } from "@/lib/storage";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const ProtectedRoute: React.FC<any> = ({ children }) => {
  const isAuthenticated = useSelector((s: any) => s.auth.isAuthenticated);

  useEffect(() => {
    const token = getToken();
    if (!token && !isAuthenticated) {
      backToLogin();
    }
  }, [isAuthenticated]);

  const token = getToken();
  if (!token && !isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
